<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon @click="onClick" v-on="on">edit</v-icon>
    </template>
    <span>設定の編集</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'IntervalReportListButtonEdit',
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    async onClick() {
      this.$emit('onClickEdit', this.id)
    },
  },
}
</script>

<style></style>
